import { cn } from 'noddi-ui-common';
import { PropsWithChildren } from 'react';
import { contentMaxWidthVariants, type LayoutContainerWidth, layoutGutterVariants } from './layoutContainer';

export type ScreenBaseWrapperWidth = LayoutContainerWidth;

interface Props {
  width?: ScreenBaseWrapperWidth;
  className?: string;
}

export const ScreenBaseWrapper = ({ children, width, className }: PropsWithChildren<Props>) => {
  return (
    <div
      className={cn(
        layoutGutterVariants({ width }),
        contentMaxWidthVariants({ width }),
        'mt-8 flex w-full flex-col pb-28 md:mt-14',
        className
      )}
    >
      {children}
    </div>
  );
};
